import { render } from "./FlatsFilter.vue?vue&type=template&id=670eb5b9"
import script from "./FlatsFilter.vue?vue&type=script&lang=js"
export * from "./FlatsFilter.vue?vue&type=script&lang=js"

import "./FlatsFilter.vue?vue&type=style&index=0&id=670eb5b9&lang=less"

import exportComponent from "D:\\panorama-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__